import React from 'react';

import { MapTo } from '@adobe/aem-spa-component-mapping';
import PropTypes from 'prop-types';

import { DownloadIcon } from 'components/Icons/DownloadIcon';
import { SubTitle } from 'components/SubTitle/SubTitle';

import './DownloadTeaser.sass';

export const DownloadTeaser = ({ title, subtext, documents }) => (
  <div className="download-teaser">
    <SubTitle notFramed className="download-teaser__title" text={title} />
    <p>{subtext}</p>
    <div className="download-teaser__document-container">
      {documents.map((document) => (
        <a target="_blank" href={document.docPath} key={document.docPath} rel="noreferrer">
          <DownloadIcon alt="Download icon" />
          {document.docTitle}
        </a>
      ))}
    </div>
  </div>
);

DownloadTeaser.propTypes = {
  title: PropTypes.string.isRequired,
  subtext: PropTypes.string.isRequired,
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      docTitle: PropTypes.string.isRequired,
      docPath: PropTypes.string.isRequired,
    })
  ),
};

DownloadTeaser.defaultProps = {
  documents: [],
};

MapTo('e-fix/components/content/downloadteaser')(DownloadTeaser);
